import { useTranslate } from "ra-core";

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

import { useEsAdmin } from "../datos/useEsAdmin";
import { useResponsables } from "../datos/useResponsables";
import { SIN_ASIGNAR, TODAS, type FiltroPersona } from "../dominio/equipo";

/** Selector «de quién» (ver useFiltroPersona). Solo para administradores. */
export const FiltroPersonaSelect = ({
  valor,
  cambiar,
}: {
  valor: FiltroPersona;
  cambiar: (v: FiltroPersona) => void;
}) => {
  const translate = useTranslate();
  const esAdmin = useEsAdmin();
  const { usuarios, nombre } = useResponsables();
  if (!esAdmin) return null;
  return (
    <Select value={valor} onValueChange={cambiar}>
      <SelectTrigger
        className="h-9 w-48"
        aria-label={translate("nevora.equipo.filtro_persona")}
        data-testid="filtro-persona"
      >
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value={TODAS}>
          {translate("nevora.equipo.todas_personas")}
        </SelectItem>
        <SelectItem value={SIN_ASIGNAR}>
          {translate("nevora.negocios.sin_asignar")}
        </SelectItem>
        {usuarios
          .filter((u) => !u.disabled)
          .map((u) => (
            <SelectItem key={String(u.id)} value={String(u.id)}>
              {nombre(u.id)}
            </SelectItem>
          ))}
      </SelectContent>
    </Select>
  );
};
